import React from 'react'
import classes from '../Browse/Browse.module.scss'
import { DisableHtmlTagScroll } from './DisableHtmlTagScroll'

export const MobileDropdown = ({
  children: dropdownContent,
}: {
  children: React.ReactNode
}) => (
  <div className={classes.mobileDropdown}>
    <DisableHtmlTagScroll />
    {dropdownContent}
  </div>
)
